export function getPercentageChange(oldNumber?: number, newNumber?: number){
    if (!oldNumber || !newNumber) return 0;

    var decreaseValue = oldNumber - newNumber;

    return -Math.round((decreaseValue / oldNumber) * 100);
}